/**
 * Pre-CTA Detector
 * Finds elements that come before the global-cta element and adds a class for styling
 */

/**
 * Add class to element before global-cta
 */
function markPreCtaElement() {
	// Find the global-cta element
	const globalCta = document.querySelector('.global-cta, [class*="global-cta"]');

	if (!globalCta) {
		return;
	}

	// Get the previous sibling element
	let previousElement = globalCta.previousElementSibling;

	// Skip over any empty or non-element siblings
	while (previousElement && (
		previousElement.nodeType !== 1 ||
		!previousElement.offsetHeight ||
		previousElement.classList.contains('is-hidden')
	)) {
		previousElement = previousElement.previousElementSibling;
	}

	if (previousElement) {
		// Remove old class first
		document.querySelectorAll('.before-global-cta').forEach(function(el) {
			el.classList.remove('before-global-cta');
			el.removeAttribute('data-position');
		});

		// Add the class
		previousElement.classList.add('before-global-cta');

		// Optional: Add a data attribute for debugging
		previousElement.setAttribute('data-position', 'pre-cta');
	}
}

/**
 * Initialize pre-CTA detector
 */
function init() {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', markPreCtaElement);
	} else {
		// DOM is already ready
		markPreCtaElement();
	}

	// Re-run when content might change (for dynamic content)
	if (typeof MutationObserver !== 'undefined') {
		const observer = new MutationObserver(function(mutations) {
			// Check if global-cta was added/removed
			let shouldRecheck = false;
			mutations.forEach(function(mutation) {
				if (mutation.addedNodes.length || mutation.removedNodes.length) {
					shouldRecheck = true;
				}
			});

			if (shouldRecheck) {
				markPreCtaElement();
			}
		});

		// Observe the body for changes
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}
}

// Initialize
init();
